import Carousel from "components/carousel/carousel";

export default Carousel
